import { call, put, select } from 'redux-saga/effects';
import { generatePIN, checkPIN } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';
import { WEBSERVICE_ERRORS } from '../errorManagement/errorCatalog';

const contextStore = state => state.context.data;

export const normalizeCheckPinFailResult = (rawData) => {
  let errorNormalized = null;

  const { response } = rawData;

  if (
    response
      && response.status === 'KO'
      && response.error
      && response.error.codigoErrorNegocio
  ) {
    switch (response.error.codigoErrorNegocio) {
      case WEBSERVICE_ERRORS.PORTABILITY_OTP_INCORRECT:
        errorNormalized = WEBSERVICE_ERRORS.PORTABILITY_OTP_INCORRECT;
        break;
      case WEBSERVICE_ERRORS.OTP_MAX_RETRIES_REACHED:
        errorNormalized = WEBSERVICE_ERRORS.OTP_MAX_RETRIES_REACHED;
        break;
      default:
        break;
    }
  }
  return errorNormalized;
};

export function* getPin(params) {
  const {
    normalizeHttpErrors,
    showError,
    phoneNumber,
    portabilityComponentId,
    reduxUpdate,
  } = params;
  try {
    const { successUpdate } = reduxUpdate;
    const context = yield select(contextStore);
    const response = yield call(
      generatePIN,
      { clientPhoneNumber: phoneNumber },
      context,
    );
    yield put(successUpdate(phoneNumber, portabilityComponentId, response));
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.GENERATE_PIN, error);

    if (showError) {
      yield put(showError(errorNormalized));
    }
    yield put(errorUpdate());
  }
}

export function* validatePin(params) {
  const {
    normalizeHttpErrors,
    showError,
    cqId,
    phoneNumber,
    pinNumber,
    pinRequestId,
    portabilityComponentId,
    reduxUpdate,
  } = params;
  try {
    const { successUpdate } = {...reduxUpdate};
    const context = yield select(contextStore);
    const request = {
      cqId,
      clientPhoneNumber: phoneNumber,
      pinToCheck: pinNumber,
      pinRequestId,
    };
    yield call(checkPIN, request, context);
    if(successUpdate){
      yield put(successUpdate(portabilityComponentId));
    }
  } catch (error) {
    const data = normalizeCheckPinFailResult(error);
    const { errorUpdate, errorInvalidUpdate, errorMaxRetriesUpdate } = {...reduxUpdate};

    switch (data) {
      case WEBSERVICE_ERRORS.PORTABILITY_OTP_INCORRECT:
        if(errorInvalidUpdate){
          yield put(errorInvalidUpdate(portabilityComponentId));
        }
        break;
      case WEBSERVICE_ERRORS.OTP_MAX_RETRIES_REACHED:
        if(errorMaxRetriesUpdate){
          yield put(errorMaxRetriesUpdate(portabilityComponentId));
        }
        break;
      default: {
        const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.CHECK_PIN, error);
        if (showError) {
          yield put(showError(errorNormalized));
        }
        if(errorUpdate){
          yield put(errorUpdate());
        }
        break;
      }
    }
  }
}
